import Point from './point';

export default class {
  constructor(id, name, coordinates) {
    this.id = id;
    this.name = name;
    this.nameLowered = name.toLowerCase();
    coordinates = coordinates || [
      {
        lat: 0,
        lon: 0,
      },
    ];
    if (coordinates.lat && coordinates.lon) {
      coordinates = [coordinates]
    }
    this.coordinates = coordinates.map((coordinate) => {
      return new Point(coordinate.lat, coordinate.lon);
    });
  }

  isPolygon() {
    return this.coordinates.length > 1;
  }

  get center() {
    return this.coordinates[0];
  }

  get lat() {
    return this.center.lat;
  }

  get lng() {
    return this.center.lng;
  }

  get latShort() {
    return this.center.latShort;
  }

  get lngShort() {
    return this.center.lngShort;
  }

  getLabelOffset() {
    return [0];
  }
}
